import { connect } from 'react-redux'
import UI from './UI'
import { AddItemToCartAction } from 'components/Cart/store'
import { switchDefaultCurrencyAction } from 'store/currency'

const mapStateToProps = ({ course, currency, support }) => ({
  Price: course.Course.Price,
  AlternativePrice: course.Course.AlternativePrice,
  PricePromo: course.Course.PricePromo,
  AlternativePricePromo: course.Course.AlternativePricePromo,
  loading: course.gettingCoursesInfos,
  initialCurrency: currency.initialCurrency,
  alternativeCurrency: currency.alternativeCurrency,
  isDefault: support.IsDefault,
  Image: course.Course.Image,
  MobileImageUrl: course.Course.MobileImageUrl,
  Title: course.Course.Title,
  Id: course.Course.Id,
  Rating: course.Course.Rating,
  ReviewersCount: course.Course.ReviewersCount,
  Duration: course.Course.Duration,
  ViewersCount: course.Course.ViewersCount,
  Slug: course.Course.Slug
})

const mapDispatchToProps = dispatch => ({
  addToCart: course => dispatch(AddItemToCartAction(course)),
  handleChangeCurrency: () => dispatch(switchDefaultCurrencyAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
